export default "__VITE_ASSET__CSQEeiLT__"